import axiosInstance from '@/services/axiosInstance'

async function processChildBiometric (number, image) {
  const data = {
    numSocioMenor: number,
    fotoBase64: image
  }
  const req = {
    url: '/rgcc-services/FuncionesSW/TramitarAprobacionAccesoBiometricoMenor',
    method: 'POST',
    data
  }

  const res = await axiosInstance(req)

  return res.data
}

export {
  processChildBiometric
}
